import TotalReservation from "./componentsWrappers/TotalReservation";
import Component from "./componentsWrappers/Component";
import EmptyTotalSection from "./empty/EmptyTotalSection";
import { FormattedMessage, useIntl } from "react-intl";

const chartSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="238"
    height="121"
    viewBox="0 0 238 121"
    fill="none"
  >
    <path
      d="M1.03125 12.2524L13.588 10.6933L30.4746 0.819092L52.9902 28.8827H76.8047L104.083 19.0085L138.722 21.6069L159.939 3.41757"
      stroke="white"
      stroke-width="1.14674"
      stroke-linecap="round"
    />
    <path
      d="M19.5978 100.004L1 100.292V112.181C1 116.599 4.58172 120.181 9 120.181H229C233.418 120.181 237 116.599 237 112.181V98.5648L204.935 102.019L179.957 101.738L153.114 101.487L113.228 103.363H77.6161L44.6087 98.1809L19.5978 100.004Z"
      fill="url(#paint0_linear_1027_10024)"
    />
    <circle cx="1.81278" cy="99.8128" r="1.81278" fill="#9999A7" />
    <circle cx="19.8128" cy="99.8128" r="1.81278" fill="#9999A7" />
    <circle cx="44.8128" cy="97.8128" r="1.81278" fill="#9999A7" />
    <circle cx="78.8128" cy="102.508" r="1.81278" fill="#9999A7" />
    <circle cx="235.813" cy="98.8128" r="1.81278" fill="#9999A7" />
    <circle cx="114.813" cy="102.508" r="1.81278" fill="#9999A7" />
    <circle cx="154.813" cy="101.813" r="1.81278" fill="#9999A7" />
    <circle cx="206.813" cy="101.813" r="1.81278" fill="#9999A7" />
    <defs>
      <linearGradient
        id="paint0_linear_1027_10024"
        x1="119"
        y1="96.8059"
        x2="118.832"
        y2="114.242"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B0B0C0" stop-opacity="0" />
        <stop offset="0.442708" stop-color="#B0B0C0" stop-opacity="0.123971" />
        <stop offset="0.9999" stop-color="#B0B0C0" stop-opacity="0.28" />
        <stop offset="1" stop-color="#B0B0C0" stop-opacity="0.26" />
      </linearGradient>
    </defs>
  </svg>
);
const TotalReservationWrapper = ({ appointment_count, percent }: any) => {
  const empty = appointment_count > 0;
  const intl = useIntl();
  return (
    <>
      {empty ? (
        <Component style={"!col-span-2 !m-0 !w-full"}>
          <TotalReservation
            secondTitle={<FormattedMessage id="total_new_reservations_title" />}
            title={
              <FormattedMessage
                id="total_new_reservations_count"
                values={{ count: appointment_count }}
              />
            }
            description={
              <FormattedMessage id="total_new_reservations_description" />
            }
            count={appointment_count}
            percent={percent}
            // icon={TotalReservationTruecon()}
          />
        </Component>
      ) : (
        <EmptyTotalSection
          secondTitle={intl.formatMessage({
            id: "totalProductsSold",
          })}
          title={
            <div>
              <span className={`mx-1 ${empty || "text-[#75757E]"}`}>0</span>
              {intl.formatMessage({
                id: "SAR",
              })}
            </div>
          }
          description=""
          // icon={TotalReservationSCGIcon()}
          paddingX="16px"
          paddingY="16px"
          chartComponent={chartSVG}
          className={"col-span-2 w-full"}
        />
      )}
    </>
  );
};

export default TotalReservationWrapper;
